import { render } from "./TurnOver.vue?vue&type=template&id=8473281a&scoped=true&ts=true"
import script from "./TurnOver.vue?vue&type=script&lang=ts"
export * from "./TurnOver.vue?vue&type=script&lang=ts"

import "./TurnOver.vue?vue&type=style&index=0&id=8473281a&scoped=true&lang=less"

import exportComponent from "D:\\work\\project\\mobile-mpe\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8473281a"]])

export default __exports__